export const getBreadCrumbs = (currentPage) => {
  const breadCrumbsArray = []
  breadCrumbsArray.push({
    title: currentPage?.innerText ?? 'Welcome to Hackolade Studio',
    href: currentPage?.href ?? 'index.html'
  })
  if (currentPage?.parentElement?.parentElement?.previousElementSibling?.href) {
    breadCrumbsArray.push({
      title:
        currentPage.parentElement.parentElement.previousElementSibling
          .innerText,
      href: currentPage.parentElement.parentElement.previousElementSibling.href
    })
    if (
      currentPage?.parentElement?.parentElement?.previousElementSibling
        ?.parentElement?.parentElement?.previousElementSibling?.href
    ) {
      breadCrumbsArray.push({
        title:
          currentPage.parentElement.parentElement.previousElementSibling
            .parentElement.parentElement.previousElementSibling.innerText,
        href:
          currentPage.parentElement.parentElement.previousElementSibling
            .parentElement.parentElement.previousElementSibling.href
      })
    }
  } else {
    return breadCrumbsArray
  }
  return breadCrumbsArray
}

export const getNavigationBtn = (linksArray, currentIndex) => {
  let prev
  let next
  let up
  if (!linksArray[currentIndex - 1]) {
    prev = false
  } else {
    prev = {
      title: linksArray[currentIndex - 1].innerText,
      href: linksArray[currentIndex - 1].href
    }
  }
  if (!linksArray[currentIndex + 1]) {
    next = false
  } else {
    next = {
      title: linksArray[currentIndex + 1].innerText,
      href: linksArray[currentIndex + 1].href
    }
  }
  if (
    linksArray[currentIndex]?.parentElement?.parentElement
      ?.previousElementSibling?.href
  ) {
    up = {
      title:
        linksArray[currentIndex].parentElement.parentElement
          .previousElementSibling.innerText,
      href:
        linksArray[currentIndex].parentElement.parentElement
          .previousElementSibling.href
    }
  } else {
    up = false
  }
  return { up, prev, next }
}

export const initializeAnchors = () => {
  const contentDiv = document.querySelector('.content')
  const titlesArray = [].slice.call(contentDiv.querySelectorAll('h2,h3'))
  titlesArray.forEach((element) => {
    const id = element.innerText
    element.id = id
    return element
  })
}

export const setRightTOC = () => {
  const content = document.getElementsByClassName('content')[0]

  const titles = [].slice.call(content.querySelectorAll('h2,h3'))
  const h3Array = [].slice.call(content.querySelectorAll('h3'))

  const TOCArray = titles.map((title) => {
    const finded = h3Array.find((item) => item.innerText === title.innerText)
    if (finded) {
      title.className = 'thirdLevelHeading'
    }
    return title
  })

  return TOCArray
}

export const setImagesBlank = (images) => {
  const imgArr = [].slice.call(images)
  imgArr.forEach((img) => {
    img.src = img.src.replace(/\/help\/lib\//g, '/help/lib/')
    img.addEventListener('click', function() {
      window.open(img.src, '_blank')
    })
  })
}

export const setLinksBlank = async (links) => {
  const linksArray = await [].slice.call(links)
  linksArray.forEach((link) => {
    link.className = 'content__link'
    if (link.title.includes('target') && link.title.includes('_blank')) {
      link.target = '_blank'
    }
    link.title = link.innerText
  })
}

export const setClasses = (array, classname) => {
  array.forEach((el) => {
    el.className = `${el.className} ${classname}`
  })
}

export const initialScrollTo = async (linksArray) => {
  setClasses(linksArray, 'sidebar__link')
  await linksArray.forEach((link) => {
    if (window.location.href.endsWith(link.href) || window.location.href.split('#')[0].endsWith(link.href) || (window.location.href.endsWith('/help/index.html') && link.href.endsWith('WelcometoHackoladeStudio.html'))) {
      link.scrollTop += 10
      link.scrollIntoView({ block: 'center' })
      link.className = 'sidebar__link-active'
    } 
  })
}

export const initializeAccordion = (ulArray) => {
  ulArray.forEach((ul) => {
    if (ul.parentElement.nodeName === 'LI') {
      ul.parentElement.insertAdjacentHTML(
        'afterbegin',
        '<span class="docsAccordion active"></span>'
      )
      ul.className = 'panel'
    }
  })
  let acc = document.getElementsByClassName('docsAccordion')
  let i
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener('click', function() {
      this.classList.toggle('active')
      let panel = this.parentElement.lastChild
      if (panel.previousSibling.style.display === 'none') {
        panel.previousSibling.style.display = 'block'
      } else {
        panel.previousSibling.style.display = 'none'
      }
    })
  }
}

export const initializeCodeCopy = (codeBlockArray) => {
  codeBlockArray.forEach((code) => {
    code.insertAdjacentHTML(
      'beforebegin',
      '<span class="copyButton">Copy &#10063;</span>'
    )
    code.previousElementSibling.addEventListener('click', copyText)
  })
  function copyText(e) {
    const initialHTML = e.target.innerHTML
    const initialClassName = e.target.className
    e.target.className = 'activeCopyBtn'
    let text = e.target.nextElementSibling.innerText
    let textArea = document.createElement('textarea')
    textArea.width = '1px'
    textArea.height = '1px'
    textArea.background = 'transparents'
    textArea.value = text
    document.body.append(textArea)
    textArea.select()
    document.execCommand('copy')
    document.body.removeChild(textArea)
    e.target.innerHTML = 'Copied &#10003;'
    setTimeout(() => {
     e.target.innerHTML = initialHTML
     e.target.className = initialClassName
    }, 2000)
  }
}
